import { render, staticRenderFns } from "./ClothesModels.vue?vue&type=template&id=327c491b&"
import script from "./ClothesModels.vue?vue&type=script&lang=js&"
export * from "./ClothesModels.vue?vue&type=script&lang=js&"
import style0 from "./ClothesModels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports